import { render, staticRenderFns } from "./ReportSummary.vue?vue&type=template&id=44df568a"
import script from "./ReportSummary.vue?vue&type=script&lang=js"
export * from "./ReportSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports